import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  CONFIRM_MODAL_ACTION,
} from "./actionTypes"

import {
  confirmModalActionSuccess,
  confirmModalActionError,
} from "./actions"

function* confirmModalAction({payload: data}) {
  try {
    const response = yield call(data.call, data.data)
    yield put(confirmModalActionSuccess(response))
  } catch (error) {
    yield put(confirmModalActionError(error))
  }
}

export function* watchConfirmModalAction() {
  yield takeEvery(CONFIRM_MODAL_ACTION, confirmModalAction);
}

function* confirmModalSaga() {
  yield all([
    fork(watchConfirmModalAction),
  ]);
}

export default confirmModalSaga
